import React, { Component } from 'react';
import client from 'features/userManage/api/client'
import {
  Modal,
  Button,
  Select,
  Input,
  Tabs,
  Form,
  Row,
  Col,
  DatePicker,
  TimePicker,
  InputNumber,
  message
} from 'antd';
import { Loader } from 'semantic-ui-react';
import moment from 'moment-timezone';
import { AgGridReact } from 'ag-grid-react';
import { Message } from 'semantic-ui-react';
import TagComponent from 'common/ui/renderers/agGrid/TagComponent';
import {
  signInGridColumns,
  leaveGridColumns,
  extraHoursGridColumns
} from './GridColumnMap';
import _ from 'lodash';

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const _createUIOptions = codes => {
  return codes.map(c => (
    <Option key={c || 'default'} value={c}>
      {c}
    </Option>
  ));
};

class UserSignInDialog extends Component {

  constructor(props) {
    super(props);
    const workingDays = this._getLastWorkingDay(3);
    this.state = {
      signRecords: [],
      leaveRecords: [],
      extraHoursApplyData: [],
      leaveData: {
        startDate: null,
        endDate: null,
        remark: ''
      },
      extraData: {
        date: moment().tz('Asia/Tokyo').format('YYYY-MM-DD'),
        applyHours: 0,
        remark: ''
      },
      clockTime: moment().tz('Asia/Tokyo'),
      workingDays: workingDays,
      selectDate: workingDays[0],
      errors: [],
      extraHoursErrors: [],
      remark: '',
      status: 'READY',
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 50,
        width: 130,
        sortable: true,
        filter: true,
        resizable: true
      },
      context: {
        gridComponent: this
      },
      pivotPanelShow: 'always',
      sideBar: {
        toolPanels: ['columns', 'filters']
      },
    }
  }

  componentDidMount() {
    this.loadSignRecords();
    this.loadLeaveRecords();
    this.loadExtraHoursRecords();
    this._loadUserConfig();
  }

  _loadUserConfig = () => {
    client.getUserClockConfig().then(resp => {
      if(!_.isEmpty(resp) && resp.clockDays)
      this.setState({
        workingDays: this._getLastWorkingDay(resp.clockDays)
      })
    });
  }

  // 检查是否在请假期间
  _isOnLeave = () => {
    const { leaveRecords } = this.state;
    const today = moment().format("YYYY-MM-DD");
    if (!leaveRecords || leaveRecords.length === 0) return false;
    return leaveRecords.some(record => {
      const startDate = moment(record.startDate).format("YYYY-MM-DD");
      const endDate = moment(record.endDate).format("YYYY-MM-DD");
      return today >= startDate && today <= endDate;
    });
  }

  loadSignRecords = async () => {
    this.setState({
      status: 'LOADING'
    })
    client.getSignRecords({}).then(resp => {
      this.setState({
        signRecords: resp ? resp.map(r => ({
          ...r,
        }
        )) : [],
        status: 'READY'
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  loadLeaveRecords = async () => {
    this.setState({
      status: 'LOADING'
    })
    client.getLeaveRecords({}).then(resp => {
      this.setState({
        leaveRecords: resp ? resp.map(r => ({
          ...r,
          startDate: moment(r.startDate).format("YYYY-MM-DD"),
          endDate: moment(r.endDate).format("YYYY-MM-DD")
        })) : [],
        status: 'READY'
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  loadExtraHoursRecords = async () => {
    this.setState({
      status: 'LOADING'
    })
    client.getSelfClockApplyRecordList({}).then(resp => {
      this.setState({
        extraHoursApplyData: resp ? resp.map(r => ({
          ...r,
          date: moment(r.startDate).format("YYYY-MM-DD"),
        })) : [],
        status: 'READY'
      })
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  _getLastWorkingDay = (days) => {
    const workingDays = [];
    let date = moment();
    workingDays.push(date.format("YYYY-MM-DD"));
    while (workingDays.length < days) {
      date = date.subtract(1, 'days');
      const dayOfWeek = date.day();
      // 排除周六(6)和周日(0)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        workingDays.push(date.format("YYYY-MM-DD"));
      }
    }
    return _.orderBy(workingDays).reverse();
  }

  _validate = () => {
    const { selectDate, remark } = this.state;
    const today = moment().format("YYYY-MM-DD");
    const errors = [];
    if (selectDate !== today && _.isEmpty(remark)) {
      errors.push('Please input remark.');
    };
    this.setState({
      errors
    })
    return _.isEmpty(errors);
  }

  _validateLeave = () => {
    const { startDate, endDate, remark } = this.state.leaveData;
    const leaveErrors = [];
    if (startDate === null) {
      leaveErrors.push('Please input startDate.');
    } else if (endDate === null) {
      leaveErrors.push('Please input endDate.');
    } else if (_.isEmpty(remark)) {
      leaveErrors.push('Please input remark.');
    }
    this.setState({
      leaveErrors
    })
    return _.isEmpty(leaveErrors);
  }

  _validateExtraHours = () => {
    const { date, applyHours, remark } = this.state.extraData;
    const extraHoursErrors = [];
    if (date === null) {
      extraHoursErrors.push('Please input date.');
    } else if (applyHours <= 0) {
      extraHoursErrors.push('Extra Hours must > 0.');
    } else if (_.isEmpty(remark)) {
      extraHoursErrors.push('Please input remark.');
    }
    this.setState({
      extraHoursErrors
    })
    return _.isEmpty(extraHoursErrors);
  }

  _createErrorPannel = () => {
    const { errors } = this.state;
    return (_.isEmpty(errors) ? ("") :
      (
        <Message error list={errors} style={{ marginBottom: '3px' }} />
      )
    )
  }

  _createExtraErrorPannel = () => {
    const { extraHoursErrors } = this.state;
    return (_.isEmpty(extraHoursErrors) ? ("") :
      (
        <Message error list={extraHoursErrors} style={{ marginBottom: '3px' }} />
      )
    )
  }

  /**
   * 检查当天 Clock In 时间与当前时间的间隔小时数
   * @returns {number|null} 间隔小时数，如果未找到 Clock In 记录则返回 null
   */
  _checkClockInOutTime = () => {
    const { signRecords, selectDate, clockTime } = this.state;

    // 查找当天的 Clock In 记录（type 为 'SIGN_IN'）
    const clockInDateTime = signRecords.find(record => {
      return record.clockDate === selectDate && record.type === 'ClockIn';
    });

    if (!clockInDateTime || !clockInDateTime.createdOn) {
      return null;
    }

    // 计算时间间隔（小时）
    const clockInTime = moment.tz(clockInDateTime.createdOn, 'YYYY-MM-DD HH:mm:ss', 'Asia/Tokyo');
    const now = moment.tz(`${selectDate} ${clockTime.format('HH:mm:ss')}`, 'YYYY-MM-DD HH:mm:ss', 'Asia/Tokyo');
    const diffHours = now.diff(clockInTime, 'hours', true);

    return diffHours;
  }

  signIn = async (type) => {
    if (!this._validate()) return;
    this._doClockIn(type);
  }

  _doClockIn = (type) => {
    const { selectDate, clockTime, remark } = this.state
    this.setState({
      status: 'LOADING'
    });

    client.signIn({ type, clockDate: selectDate, remark, createdOn: `${selectDate} ${clockTime.format('HH:mm:ss')}` }).then(resp => {
      console.log('sign success, type =' + type);
      message.info(`${type} success.`)
      this.setState({
        remark: '',
      });
      this.loadSignRecords();
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  saveLeave = () => {
    const { leaveData } = this.state
    if (!this._validateLeave()) return;
    this.setState({
      status: 'LOADING'
    })
    client.saveLeaveRecord(leaveData).then(resp => {
      this.loadLeaveRecords();
      this.setState({
        leaveData: {
          startDate: null,
          endDate: null,
          remark: ''
        }
      });
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  applyExtraHours = () => {
    const { extraData } = this.state
    if (!this._validateExtraHours()) return;
    this.setState({
      status: 'LOADING'
    })
    client.applyClockHours(extraData).then(resp => {
      this.loadExtraHoursRecords();
      this.setState({
        extraData: {
          date: null,
          applyHours: 0,
          remark: ''
        }
      });
    }).catch(err => {
      console.log(err);
      this.setState({
        status: 'READY'
      })
    })
  }

  _closeModal = () => {
    this.props.closeDialog();
  };

  /**
   * 检查当天是否已有签到记录
   * @returns {boolean} 当天是否已签到
   */
  _isSignedInToday = () => {
    const { signRecords, selectDate } = this.state;
    const today = selectDate; // 获取当天日期 YYYY-MM-DD
    const signRecordList = signRecords ? signRecords.filter(r => r.type === 'ClockIn') : [];
    return signRecordList.some(record => {
      return record.clockDate === today;
    });
  }

  _isSignedOutToday = () => {
    const { signRecords, selectDate } = this.state;
    const today = selectDate; // 获取当天日期 YYYY-MM-DD
    const signRecordList = signRecords ? signRecords.filter(r => r.type === 'ClockOut') : [];
    return signRecordList.some(record => {
      return record.clockDate === today;
    });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.sizeColumnsToFit();
  };

  onLeaveGridReady = params => {
    this.leaveGridApi = params.api;
    this.leaveColumnApi = params.columnApi;

    this.leaveGridApi.sizeColumnsToFit();
  };

  _createSignRecordGrid = () => {
    const { status, signRecords } = this.state;
    const showData = signRecords ? _.orderBy(signRecords, ['createdOn'], ['desc']) : [];
    return (
      <div className={`ag-theme-balham-dark grid-wrapper`} style={{ height: '400px' }}>
        {!status === 'LOADING' ? (
          <Loader active inverted content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={signInGridColumns}
            defaultColDef={this.state.defaultColDef}
            rowData={showData}
            suppressAggFuncInHeader={true}
            animateRows={true}
            enableRangeSelection={true}
            pivotPanelShow={false}
            rowSelection="single"
            getRowNodeId={params => params.id}
            onGridReady={this.onGridReady}
          />
        )}
      </div>
    )
  }

  selectDateChange = (value) => {
    this.setState({
      selectDate: value,
      remark: null,
    }, this._validate)
  }

  _onClockTimeChange = (value) => {
    this.setState({
      clockTime: value,
    })
  }

  _createInput = () => {
    const { selectDate } = this.state;
    const today = moment().format("YYYY-MM-DD");
    if (selectDate === today) return;
    return (
      <div style={{ marginBottom: '5px' }}>
        <Input
          size="small"
          placeholder="Please input clock remark"
          value={this.state.remark}
          onChange={e => this.setState({ remark: e.target.value }, this._validate)}
        />
      </div>
    )
  }

  _isWeekend = () => {
    const dayOfWeek = moment().day();
    return dayOfWeek === 0 || dayOfWeek === 6;
  }

  _createClockPanel = () => {
    const { status } = this.state;
    const isSignedIn = this._isSignedInToday();
    return (
      <>
        <div style={{ textAlign: 'left' }}>
          <Select
            value={this.state.selectDate}
            size='small'
            onChange={(value) => {
              this.selectDateChange(value);
            }}
          >
            {_createUIOptions(this.state.workingDays)}
          </Select>
          <span style={{ marginLeft: '5px' }}><b>Clock Time:</b></span>
          <TimePicker size="small" value={this.state.clockTime} onChange={(value) => {
            this._onClockTimeChange(value);
          }} />
        </div>
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <Button
            type={isSignedIn ? "default" : "primary"}
            shape="circle"
            style={{ height: '99px', width: '99px', marginBottom: '10px' }}
            loading={status === 'LOADING'}
            onClick={() => this.signIn(isSignedIn ? 'ClockOut' : 'ClockIn')}
          >
            {isSignedIn ? 'Clock Out' : 'Clock In'}
          </Button>
        </div>
        {this._createInput()}
        {this._createErrorPannel()}
        {this._createSignRecordGrid()}
      </>
    )
  }

  _createLeavePanel = () => {
    return (
      <div>
        {this._createLeaveForm()}
        {this._createLeaveAgGrid()}
      </div>
    )
  }

  _onLeaveGridClick = (event) => {
    if (!event.data) return;
    this.setState({
      leaveData: {
        ...event.data
      }
    });
  }

  _createLeaveAgGrid = () => {
    const { status, leaveRecords } = this.state;
    const showData = leaveRecords ? _.orderBy(leaveRecords, ['createdOn'], ['desc']) : [];
    return (
      <div className={`ag-theme-balham-dark grid-wrapper`} style={{ height: '400px' }}>
        {!status === 'LOADING' ? (
          <Loader active inverted content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={leaveGridColumns}
            defaultColDef={this.state.defaultColDef}
            rowData={showData}
            suppressAggFuncInHeader={true}
            animateRows={true}
            enableRangeSelection={true}
            pivotPanelShow={false}
            rowSelection="single"
            getRowNodeId={params => params.id}
            onRowDoubleClicked={this._onLeaveGridClick}
            onGridReady={this.onLeaveGridReady}
          />
        )}
      </div>
    )
  }

  _onLeaveFormChange = ({ name, value }) => {
    const { leaveData } = this.state;
    this.setState({
      leaveData: {
        ...leaveData,
        [name]: value
      }
    })
  }

  _createLeaveForm = () => {
    const { leaveData } = this.state;
    return (
      <Form
        className="ant-advanced-search-form"
      >
        <Row>
          <Col span={10}>
            <Form.Item
              label={'Start Date'}
              required
            >
              <DatePicker value={leaveData.startDate ? moment(leaveData.startDate, 'YYYY-MM-DD') : null} format={'YYYY-MM-DD'}
                onChange={(date, dateString) => {
                  this._onLeaveFormChange({ name: 'startDate', value: dateString });
                }} />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label={'End Date'}
              required
            >
              <DatePicker value={leaveData.endDate ? moment(leaveData.endDate, 'YYYY-MM-DD') : null} format={'YYYY-MM-DD'}
                onChange={(date, dateString) => {
                  this._onLeaveFormChange({ name: 'endDate', value: dateString });
                }} />
            </Form.Item>
          </Col>
          <Col span={19}>
            <Form.Item
              label={'Remark'}
              required
            >
              <Input placeholder='Please input reason' value={leaveData.remark} onChange={e => {
                this._onLeaveFormChange({ name: 'remark', value: e.target.value });
              }} />
            </Form.Item>
          </Col>
          <Col span={5}>
            <div style={{ textAlign: 'right' }}>
              <Button type="primary" onClick={() => this.saveLeave()}>Apply Vacation</Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }

  _createExtraPanel = () => {
    return (
      <div>
        {this._createExtraForm()}
        {this._createExtraAgGrid()}
      </div>
    )
  }

  onExtraGridReady = params => {
    this.extraGridApi = params.api;
    this.extraColumnApi = params.columnApi;

    this.extraGridApi.sizeColumnsToFit();
  };

  _createExtraAgGrid = () => {
    const { status, extraHoursApplyData } = this.state;
    const showData = extraHoursApplyData ? _.orderBy(extraHoursApplyData, ['createdOn'], ['desc']) : [];
    return (
      <div className={`ag-theme-balham-dark grid-wrapper`} style={{ height: '400px' }}>
        {!status === 'LOADING' ? (
          <Loader active inverted content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={extraHoursGridColumns}
            defaultColDef={this.state.defaultColDef}
            rowData={showData}
            suppressAggFuncInHeader={true}
            animateRows={true}
            enableRangeSelection={true}
            pivotPanelShow={false}
            rowSelection="single"
            frameworkComponents={{
              tagComponent: TagComponent
            }}
            getRowNodeId={params => params.id}
            onGridReady={this.onExtraGridReady}
          />
        )}
      </div>
    )
  }

  _onExtraFormChange = ({ name, value }) => {
    const { extraData } = this.state;
    this.setState({
      extraData: {
        ...extraData,
        [name]: value
      }
    })
  }

  _createExtraForm = () => {
    const { extraData } = this.state;
    return (
      <Form
        className="ant-advanced-search-form"
      >
        <Row>
          <Col span={10}>
            <Form.Item
              label={'Date'}
              required
            >
              <DatePicker value={extraData.date ? moment(extraData.date, 'YYYY-MM-DD') : null} format={'YYYY-MM-DD'}
                onChange={(date, dateString) => {
                  this._onExtraFormChange({ name: 'date', value: dateString });
                }} />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label={'Extra Hours'}
              required
            >
              <InputNumber value={extraData.applyHours} onChange={value => {
                this._onExtraFormChange({ name: 'applyHours', value });
              }} />
            </Form.Item>
          </Col>
          <Col span={19}>
            <Form.Item
              label={'Remark'}
              required
            >
              <Input placeholder='Please input reason' value={extraData.remark} onChange={e => {
                this._onExtraFormChange({ name: 'remark', value: e.target.value });
              }} />
            </Form.Item>
          </Col>
          <Col span={5}>
            <div style={{ textAlign: 'right' }}>
              <Button type="primary" onClick={() => this.applyExtraHours()}>Apply Extra</Button>
            </div>
          </Col>
          {!_.isEmpty(this.state.extraHoursErrors) && <Col span={24}>
            {this._createExtraErrorPannel()}
          </Col>}
        </Row>
      </Form>
    );
  }

  _createTabs = () => {
    return (
      <Tabs>
        <TabPane tab="Clock In/Out" key="1">
          {this._createClockPanel()}
        </TabPane>
        <TabPane tab="Extra Hours" key="2">
          {this._createExtraPanel()}
        </TabPane>
        <TabPane tab="Vacation" key="3">
          {this._createLeavePanel()}
        </TabPane>
      </Tabs>
    );
  }

  render() {
    return (
      <Modal
        size="large"
        visible={true}
        title={`Clock In/Out`}
        width={700}
        style={{ height: 600 }}
        bodyStyle={{ paddingTop: '5px' }}
        footer={[
          <Button size="small" type="primary"
            onClick={() => { this._closeModal() }}>
            Close
          </Button>
        ]}
        closable={false}
      >
        {this._createTabs()}
      </Modal>
    );
  }
}

export default UserSignInDialog;
